import { TextField, TextFieldProps } from '@mui/material';
import { AppModels, Lang } from 'cdx-common';
import React from 'react';

export const ModelTextfield = <T extends BaseAttrs, K extends keyof T>(props: TextFieldProps & {
    model: T,
    modelType: AppModels,
    row: K;
}) => {

    const { model, modelType, helperText, value, onChange, ...propRest } = props;
    const [val, setVal] = React.useState<unknown>();
    React.useEffect(() => {
        setVal(props.model[props.row]);
    }, []);

    return <TextField
        value={val}
        onChange={event => {
            setVal(event.target.value);
            onChange && onChange(event);
        }}
        label={Lang('labels.' + props.modelType + '.' + props.row.toString())}
        error={!!props.model?.__errors?.[props.row.toString()] || !!props.model?.__err}
        helperText={props.model?.__errors?.[props.row.toString()] ?? props.model?.__err ?? helperText}
        {...propRest} />;
};
